// AI-generated from Figma frame 212:6116 (Icon overview).
// Mixed outlined/filled icons used in the design system overview.
export const FIGMA_ICONS = [
  {
    name: 'menu',
    path: 'assets/icons/material/menu.svg',
  },
  {
    name: 'menu_open',
    path: 'assets/icons/material/menu_open.svg',
  },
  {
    name: 'check',
    path: 'assets/icons/material/check.svg',
  },
  {
    name: 'visibility_off',
    path: 'assets/icons/material/visibility_off.svg',
  },
  {
    name: 'local_activity',
    path: 'assets/icons/material/local_activity.svg',
  },
  {
    name: 'fast_rewind',
    path: 'assets/icons/material/fast_rewind-fill.svg',
  },
  {
    name: 'pause',
    path: 'assets/icons/material/pause-fill.svg',
  },
  {
    name: 'skip_previous',
    path: 'assets/icons/material/skip_previous-fill.svg',
  },
  {
    name: 'play_arrow',
    path: 'assets/icons/material/play_arrow-fill.svg',
  },
  {
    name: 'fast_forward',
    path: 'assets/icons/material/fast_forward-fill.svg',
  },
  {
    name: 'skip_next',
    path: 'assets/icons/material/skip_next-fill.svg',
  },
  {
    name: 'flip',
    path: 'assets/icons/material/flip.svg',
  },
  {
    name: 'settings_power',
    path: 'assets/icons/material/settings_power.svg',
  },
  {
    name: 'power_settings_new',
    path: 'assets/icons/material/power_settings_new.svg',
  },
  {
    name: 'restart_alt',
    path: 'assets/icons/material/restart_alt.svg',
  },
  {
    name: 'more_vert',
    path: 'assets/icons/material/more_vert.svg',
  },
  {
    name: 'more_horiz',
    path: 'assets/icons/material/more_horiz.svg',
  },
  {
    name: 'rule',
    path: 'assets/icons/material/rule.svg',
  },
  {
    name: 'directions_bus',
    path: 'assets/icons/material/directions_bus.svg',
  },
  {
    name: 'directions_transit',
    path: 'assets/icons/material/directions_subway.svg',
  },
  {
    name: 'directions_car',
    path: 'assets/icons/material/directions_car.svg',
  },
  {
    name: 'search',
    path: 'assets/icons/material/search.svg',
  },
  {
    name: 'add',
    path: 'assets/icons/material/add.svg',
  },
  {
    name: 'local_taxi',
    path: 'assets/icons/material/local_taxi.svg',
  },
  {
    name: 'check_box',
    path: 'assets/icons/material/check_box.svg',
  },
  {
    name: 'check_box_outline_blank',
    path: 'assets/icons/material/check_box_outline_blank.svg',
  },
  {
    name: 'indeterminate_check_box',
    path: 'assets/icons/material/indeterminate_check_box.svg',
  },
  {
    name: 'support',
    path: 'assets/icons/material/support.svg',
  },
  {
    name: 'mail_outline',
    path: 'assets/icons/material/mail.svg',
  },
  {
    name: 'account_circle',
    path: 'assets/icons/material/account_circle.svg',
  },
  {
    name: 'person_outline',
    path: 'assets/icons/material/person.svg',
  },
  {
    name: 'person_add',
    path: 'assets/icons/material/person_add.svg',
  },
  {
    name: 'chat_bubble',
    path: 'assets/icons/material/chat_bubble.svg',
  },
  {
    name: 'chat_bubble_outline',
    path: 'assets/icons/material/chat.svg',
  },
  {
    name: 'light_mode',
    path: 'assets/icons/material/light_mode.svg',
  },
  {
    name: 'dark_mode',
    path: 'assets/icons/material/dark_mode.svg',
  },
  {
    name: 'delete',
    path: 'assets/icons/material/delete.svg',
  },
  {
    name: 'visibility',
    path: 'assets/icons/material/visibility.svg',
  },
  {
    name: 'radio_button_checked',
    path: 'assets/icons/material/radio_button_checked.svg',
  },
  {
    name: 'radio_button_unchecked',
    path: 'assets/icons/material/radio_button_unchecked.svg',
  },
  {
    name: 'folder',
    path: 'assets/icons/material/folder.svg',
  },
  {
    name: 'arrow_right',
    path: 'assets/icons/material/arrow_right.svg',
  },
  {
    name: 'arrow_left',
    path: 'assets/icons/material/arrow_left.svg',
  },
  {
    name: 'arrow_drop_up',
    path: 'assets/icons/material/arrow_drop_up-round.svg',
  },
  {
    name: 'arrow_drop_down',
    path: 'assets/icons/material/arrow_drop_down-round.svg',
  },
  {
    name: 'exposure',
    path: 'assets/icons/material/exposure.svg',
  },
  {
    name: 'navigate_before',
    path: 'assets/icons/material/chevron_left.svg',
  },
  {
    name: 'navigate_next',
    path: 'assets/icons/material/chevron_right.svg',
  },
  {
    name: 'expand_more',
    path: 'assets/icons/material/keyboard_arrow_down.svg',
  },
  {
    name: 'expand_less',
    path: 'assets/icons/material/keyboard_arrow_up.svg',
  },
  {
    name: 'file_upload',
    path: 'assets/icons/material/upload_file.svg',
  },
  {
    name: 'file_download',
    path: 'assets/icons/material/download.svg',
  },
  {
    name: 'mobile_friendly',
    path: 'assets/icons/material/mobile.svg',
  },
  {
    name: 'attach_file',
    path: 'assets/icons/material/attach_file.svg',
  },
  {
    name: 'share',
    path: 'assets/icons/material/share.svg',
  },
  {
    name: 'keyboard',
    path: 'assets/icons/material/keyboard.svg',
  },
  {
    name: 'check_small',
    path: 'assets/icons/material/check_small.svg',
  },
  {
    name: 'check_indeterminate_small',
    path: 'assets/icons/material/check_indeterminate_small.svg',
  },
  {
    name: 'remove',
    path: 'assets/icons/material/remove.svg',
  },
  {
    name: 'access_time',
    path: 'assets/icons/material/schedule.svg',
  },
  {
    name: 'keyboard_return',
    path: 'assets/icons/material/keyboard_return.svg',
  },
  {
    name: 'label',
    path: 'assets/icons/material/label.svg',
  },
  {
    name: 'forward_to_inbox',
    path: 'assets/icons/material/forward_to_inbox.svg',
  },
  {
    name: 'mic',
    path: 'assets/icons/material/mic.svg',
  },
  {
    name: 'language',
    path: 'assets/icons/material/language.svg',
  },
  {
    name: 'translate',
    path: 'assets/icons/material/translate.svg',
  },
  {
    name: 'gif',
    path: 'assets/icons/material/gif.svg',
  },
  {
    name: 'content_cut',
    path: 'assets/icons/material/content_cut.svg',
  },
  {
    name: 'workspace_premium',
    path: 'assets/icons/material/workspace_premium.svg',
  },
  {
    name: 'token',
    path: 'assets/icons/material/token.svg',
  },
  {
    name: 'tune',
    path: 'assets/icons/material/tune.svg',
  },
  {
    name: 'domain',
    path: 'assets/icons/material/domain.svg',
  },
  {
    name: 'add_moderator',
    path: 'assets/icons/material/add_moderator.svg',
  },
  {
    name: 'gpp_bad',
    path: 'assets/icons/material/gpp_bad.svg',
  },
  {
    name: 'info',
    path: 'assets/icons/material/info.svg',
  },
  {
    name: 'auto_graph',
    path: 'assets/icons/material/query_stats.svg',
  },
  {
    name: 'mail',
    path: 'assets/icons/material/mail.svg',
  },
  {
    name: 'filter_drama',
    path: 'assets/icons/material/filter_drama.svg',
  },
  {
    name: 'vpn_lock',
    path: 'assets/icons/material/vpn_lock.svg',
  },
  {
    name: 'bug_report',
    path: 'assets/icons/material/bug_report.svg',
  },
  {
    name: 'crop_free',
    path: 'assets/icons/material/crop_free.svg',
  },
  {
    name: 'explore',
    path: 'assets/icons/material/explore.svg',
  },
  {
    name: 'local_police',
    path: 'assets/icons/material/local_police.svg',
  },
  {
    name: 'energy_savings_leaf',
    path: 'assets/icons/material/energy_savings_leaf.svg',
  },
  {
    name: 'rocket_launch',
    path: 'assets/icons/material/rocket_launch.svg',
  },
  {
    name: 'emoji_objects',
    path: 'assets/icons/material/emoji_objects.svg',
  },
  {
    name: 'browse_gallery',
    path: 'assets/icons/material/browse_gallery.svg',
  },
  {
    name: 'dock_to_right',
    path: 'assets/icons/material/dock_to_right.svg',
  },
  {
    name: 'dock',
    path: 'assets/icons/material/dock_to_bottom.svg',
  },
  {
    name: 'transgender',
    path: 'assets/icons/material/transgender.svg',
  },
  {
    name: 'female',
    path: 'assets/icons/material/female.svg',
  },
  {
    name: 'contract',
    path: 'assets/icons/material/contract.svg',
  },
  {
    name: 'description',
    path: 'assets/icons/material/description.svg',
  },
  {
    name: 'system_update_alt',
    path: 'assets/icons/material/system_update_alt.svg',
  },
  {
    name: 'schedule',
    path: 'assets/icons/material/schedule.svg',
  },
  {
    name: 'trending_flat',
    path: 'assets/icons/material/trending_flat.svg',
  },
  {
    name: 'trending_down',
    path: 'assets/icons/material/trending_down.svg',
  },
  {
    name: 'trending_up',
    path: 'assets/icons/material/trending_up.svg',
  },
  {
    name: 'eject',
    path: 'assets/icons/material/eject.svg',
  },
  {
    name: 'view_module',
    path: 'assets/icons/material/view_module.svg',
  },
  {
    name: 'bluetooth',
    path: 'assets/icons/material/bluetooth.svg',
  },
  {
    name: 'open_in_full',
    path: 'assets/icons/material/open_in_full.svg',
  },
  {
    name: 'male',
    path: 'assets/icons/material/male.svg',
  },
  {
    name: 'laptop_mac',
    path: 'assets/icons/material/laptop_mac.svg',
  },
  {
    name: 'near_me',
    path: 'assets/icons/material/near_me.svg',
  },
  {
    name: 'gallery_thumbnail',
    path: 'assets/icons/material/gallery_thumbnail.svg',
  },
  {
    name: 'photo_library',
    path: 'assets/icons/material/photo_library.svg',
  },
  {
    name: 'refresh',
    path: 'assets/icons/material/refresh.svg',
  },
  {
    name: 'desktop_windows',
    path: 'assets/icons/material/desktop_windows.svg',
  },
  {
    name: 'density_large',
    path: 'assets/icons/material/density_large.svg',
  },
  {
    name: 'density_medium',
    path: 'assets/icons/material/density_medium.svg',
  },
  {
    name: 'density_small',
    path: 'assets/icons/material/density_small.svg',
  },
  {
    name: 'cancel',
    path: 'assets/icons/material/cancel.svg',
  },
  {
    name: 'local_shipping',
    path: 'assets/icons/material/local_shipping.svg',
  },
  {
    name: 'link_off',
    path: 'assets/icons/material/link_off.svg',
  },
  {
    name: 'link',
    path: 'assets/icons/material/link.svg',
  },
  {
    name: 'cloud_off',
    path: 'assets/icons/material/cloud_off.svg',
  },
  {
    name: 'inventory_2',
    path: 'assets/icons/material/inventory_2.svg',
  },
  {
    name: 'save',
    path: 'assets/icons/material/save.svg',
  },
  {
    name: 'file_save',
    path: 'assets/icons/material/file_save.svg',
  },
  {
    name: 'drag_indicator',
    path: 'assets/icons/material/drag_indicator.svg',
  },
  {
    name: 'bolt',
    path: 'assets/icons/material/bolt.svg',
  },
  {
    name: 'bolt_filled',
    path: 'assets/icons/material/bolt-fill.svg',
  },
  {
    name: 'photo_camera',
    path: 'assets/icons/material/photo_camera.svg',
  },
  {
    name: 'photo_camera_filled',
    path: 'assets/icons/material/photo_camera-fill.svg',
  },
  {
    name: 'close',
    path: 'assets/icons/material/close.svg',
  },
  {
    name: 'close_filled',
    path: 'assets/icons/material/close-fill.svg',
  },
  {
    name: 'videocam',
    path: 'assets/icons/material/videocam.svg',
  },
  {
    name: 'videocam_filled',
    path: 'assets/icons/material/videocam-fill.svg',
  },
  {
    name: 'subtitles',
    path: 'assets/icons/material/subtitles.svg',
  },
  {
    name: 'subtitles_filled',
    path: 'assets/icons/material/subtitles-fill.svg',
  },
  {
    name: 'subtitles_off',
    path: 'assets/icons/material/subtitles_off.svg',
  },
  {
    name: 'subtitles_off_filled',
    path: 'assets/icons/material/subtitles_off-fill.svg',
  },
  {
    name: 'lan',
    path: 'assets/icons/material/lan.svg',
  },
  {
    name: 'lan_filled',
    path: 'assets/icons/material/lan-fill.svg',
  },
  {
    name: 'credit_card_filled',
    path: 'assets/icons/material/credit_card-fill.svg',
  },
  {
    name: 'filter_list_off',
    path: 'assets/icons/material/filter_list_off.svg',
  },
  {
    name: 'filter_list_off_filled',
    path: 'assets/icons/material/filter_list_off-fill.svg',
  },
  {
    name: 'filter_list',
    path: 'assets/icons/material/filter_list.svg',
  },
  {
    name: 'filter_list_filled',
    path: 'assets/icons/material/filter_list-fill.svg',
  },
  {
    name: 'notifications_active',
    path: 'assets/icons/material/notifications_active.svg',
  },
  {
    name: 'notifications_off',
    path: 'assets/icons/material/notifications_off.svg',
  },
  {
    name: 'notifications',
    path: 'assets/icons/material/notifications.svg',
  },
  {
    name: 'wifi_1_bar',
    path: 'assets/icons/material/wifi_1_bar.svg',
  },
  {
    name: 'wifi_2_bar',
    path: 'assets/icons/material/wifi_2_bar.svg',
  },
  {
    name: 'wifi',
    path: 'assets/icons/material/wifi.svg',
  },
  {
    name: 'signal_wifi_off',
    path: 'assets/icons/material/signal_wifi_off.svg',
  },
  {
    name: 'signal_wifi_statusbar_not_connected',
    path: 'assets/icons/material/signal_wifi_statusbar_not_connected.svg',
  },
  {
    name: 'signal_wifi_4_bar',
    path: 'assets/icons/material/signal_wifi_4_bar.svg',
  },
  {
    name: 'wifi_notification',
    path: 'assets/icons/material/wifi_notification.svg',
  },
  {
    name: 'share_filled',
    path: 'assets/icons/material/share-fill.svg',
  },
  {
    name: 'lock_open',
    path: 'assets/icons/material/lock_open.svg',
  },
  {
    name: 'lock_open_filled',
    path: 'assets/icons/material/lock_open-fill.svg',
  },
  {
    name: 'lock',
    path: 'assets/icons/material/lock.svg',
  },
  {
    name: 'lock_filled',
    path: 'assets/icons/material/lock-fill.svg',
  },
  {
    name: 'settings_filled',
    path: 'assets/icons/material/settings-fill.svg',
  },
  {
    name: 'bookmark',
    path: 'assets/icons/material/bookmark.svg',
  },
  {
    name: 'login',
    path: 'assets/icons/material/login.svg',
  },
  {
    name: 'logout',
    path: 'assets/icons/material/logout.svg',
  },
  {
    name: 'map',
    path: 'assets/icons/material/map.svg',
  },
  {
    name: 'subdirectory_arrow_right',
    path: 'assets/icons/material/subdirectory_arrow_right.svg',
  },
  {
    name: 'edit',
    path: 'assets/icons/material/edit.svg',
  },
  {
    name: 'credit_card',
    path: 'assets/icons/material/credit_card.svg',
  },
  {
    name: 'stacked_bar_chart',
    path: 'assets/icons/material/stacked_bar_chart.svg',
  },
  {
    name: 'table',
    path: 'assets/icons/material/table.svg',
  },
  {
    name: 'table_chart',
    path: 'assets/icons/material/table_chart.svg',
  },
  {
    name: 'content_copy',
    path: 'assets/icons/material/content_copy.svg',
  },
  {
    name: 'balance',
    path: 'assets/icons/material/balance.svg',
  },
  {
    name: 'verified',
    path: 'assets/icons/material/verified.svg',
  },
  {
    name: 'hourglass_bottom',
    path: 'assets/icons/material/hourglass_bottom.svg',
  },
  {
    name: 'home',
    path: 'assets/icons/material/home.svg',
  },
  {
    name: 'groups',
    path: 'assets/icons/material/groups.svg',
  },
  {
    name: 'contract_delete',
    path: 'assets/icons/material/contract_delete.svg',
  },
  {
    name: 'contract_edit',
    path: 'assets/icons/material/contract_edit.svg',
  },
  {
    name: 'nightlight',
    path: 'assets/icons/material/nightlight.svg',
  },
  {
    name: 'clear_night',
    path: 'assets/icons/ionity/clear_night.svg',
  },
  {
    name: 'routine',
    path: 'assets/icons/material/routine.svg',
  },
  {
    name: 'wb_sunny',
    path: 'assets/icons/material/wb_sunny.svg',
  },
  {
    name: 'view_column',
    path: 'assets/icons/material/view_column.svg',
  },
  {
    name: 'add_column_right',
    path: 'assets/icons/material/add_column_right.svg',
  },
  {
    name: 'splitscreen',
    path: 'assets/icons/material/splitscreen.svg',
  },
  {
    name: 'splitscreen_vertical_add',
    path: 'assets/icons/material/splitscreen_vertical_add.svg',
  },
  {
    name: 'alarm',
    path: 'assets/icons/material/alarm.svg',
  },
  {
    name: 'alarm_smart_wake',
    path: 'assets/icons/material/alarm_smart_wake.svg',
  },
  {
    name: 'drag_handle',
    path: 'assets/icons/material/drag_handle.svg',
  },
  {
    name: 'dashboard',
    path: 'assets/icons/material/dashboard.svg',
  },
  {
    name: 'contacts',
    path: 'assets/icons/material/contacts.svg',
  },
  {
    name: 'payments',
    path: 'assets/icons/material/payments.svg',
  },
  {
    name: 'insert_chart',
    path: 'assets/icons/material/insert_chart.svg',
  },
  {
    name: 'settings',
    path: 'assets/icons/material/settings.svg',
  },
  {
    name: 'group',
    path: 'assets/icons/material/group.svg',
  },
  {
    name: 'history',
    path: 'assets/icons/material/history.svg',
  },
  {
    name: 'autorenew',
    path: 'assets/icons/material/autorenew.svg',
  },
  {
    name: 'traffic',
    path: 'assets/icons/material/traffic.svg',
  },
  {
    name: 'traffic_jam',
    path: 'assets/icons/material/traffic_jam.svg',
  },
  {
    name: 'percent',
    path: 'assets/icons/material/percent.svg',
  },
  {
    name: 'open_in_new',
    path: 'assets/icons/material/open_in_new.svg',
  },
  {
    name: 'gpp_maybe',
    path: 'assets/icons/material/gpp_maybe.svg',
  },
  {
    name: 'cookie',
    path: 'assets/icons/material/cookie.svg',
  },
  {
    name: 'cookie_off',
    path: 'assets/icons/material/cookie_off.svg',
  },
  {
    name: 'restaurant',
    path: 'assets/icons/material/restaurant.svg',
  },
  {
    name: 'local_cafe',
    path: 'assets/icons/material/local_cafe.svg',
  },
  {
    name: 'fastfood',
    path: 'assets/icons/material/fastfood.svg',
  },
  {
    name: 'wc',
    path: 'assets/icons/material/wc.svg',
  },
  {
    name: 'step_out',
    path: 'assets/icons/material/step_out.svg',
  },
  {
    name: 'step_into',
    path: 'assets/icons/material/step_into.svg',
  },
  {
    name: 'event',
    path: 'assets/icons/material/event.svg',
  },
  {
    name: 'edit_calendar',
    path: 'assets/icons/material/edit_calendar.svg',
  },
  {
    name: 'calendar_month',
    path: 'assets/icons/material/calendar_month.svg',
  },
  {
    name: 'calendar_today',
    path: 'assets/icons/material/calendar_today.svg',
  },
  {
    name: 'calendar_clock',
    path: 'assets/icons/material/calendar_clock.svg',
  },
  {
    name: 'calendar_add_on',
    path: 'assets/icons/material/calendar_add_on.svg',
  },
  {
    name: 'event_repeat',
    path: 'assets/icons/material/event_repeat.svg',
  },
  {
    name: 'event_upcoming',
    path: 'assets/icons/material/event_upcoming.svg',
  },
  {
    name: 'emoji_food_beverage',
    path: 'assets/icons/material/emoji_food_beverage.svg',
  },
  {
    name: 'construction',
    path: 'assets/icons/material/construction.svg',
  },
  {
    name: 'check_circle',
    path: 'assets/icons/material/check_circle.svg',
  },
  {
    name: 'check_circle_filled',
    path: 'assets/icons/material/check_circle-fill.svg',
  },
  {
    name: 'warning',
    path: 'assets/icons/material/warning.svg',
  },
  {
    name: 'warning_filled',
    path: 'assets/icons/material/warning-fill.svg',
  },
  {
    name: 'error',
    path: 'assets/icons/material/error.svg',
  },
  {
    name: 'error_filled',
    path: 'assets/icons/material/error-fill.svg',
  },
  {
    name: 'stop_circle',
    path: 'assets/icons/material/stop_circle.svg',
  },
  {
    name: 'stop_circle_filled',
    path: 'assets/icons/material/stop_circle-fill.svg',
  },
  {
    name: 'play_circle',
    path: 'assets/icons/material/play_circle.svg',
  },
  {
    name: 'play_circle_filled',
    path: 'assets/icons/material/play_circle-fill.svg',
  },
  {
    name: 'fingerprint',
    path: 'assets/icons/material/fingerprint.svg',
  },
  {
    name: 'hourglass_top',
    path: 'assets/icons/material/hourglass_top.svg',
  },
  {
    name: 'device_thermostat',
    path: 'assets/icons/material/device_thermostat.svg',
  },
  {
    name: 'delivery_truck_speed',
    path: 'assets/icons/material/delivery_truck_speed.svg',
  },
  {
    name: 'charging_port_03_connector',
    path: 'assets/icons/ionity/charging_port_03_connector.svg',
  },
  {
    name: 'charging_port_ccs_type_2_1_connector',
    path: 'assets/icons/ionity/charging_port_ccs_type_2_1_connector.svg',
  },
  {
    name: 'charging_port_chademo_1_connector',
    path: 'assets/icons/ionity/charging_port_chademo_1_connector.svg',
  },
  {
    name: 'charging_port_04_connector',
    path: 'assets/icons/ionity/charging_port_04_connector.svg',
  },
  {
    name: 'generic',
    path: 'assets/icons/ionity/generic.svg',
  },
  {
    name: 'clock_at_noon',
    path: 'assets/icons/ionity/clock_at_noon.svg',
  },
  {
    name: 'eco_plug',
    path: 'assets/icons/ionity/eco_plug.svg',
  },
  {
    name: 'message',
    path: 'assets/icons/ionity/message.svg',
  },
  {
    name: 'station_1',
    path: 'assets/icons/ionity/station_1.svg',
  },
  {
    name: 'keep',
    path: 'assets/icons/ionity/keep.svg',
  },
  {
    name: 'keep_filled',
    path: 'assets/icons/ionity/keep_filled.svg',
  },
  {
    name: 'ev_station',
    path: 'assets/icons/material/ev_station.svg',
  },
  {
    name: 'battery_charging_80',
    path: 'assets/icons/material/battery_charging_80.svg',
  },
  {
    name: 'arrow_back',
    path: 'assets/icons/material/arrow_back.svg',
  },
  {
    name: 'picture_as_pdf',
    path: 'assets/icons/material/picture_as_pdf.svg',
  },
  // Criterion-card icons not present in the original Figma export.
  // Material assets are generated by tools/sync-material-icons.ts during the atoms build.
  {
    name: 'battery_charging_full',
    path: 'assets/icons/material/battery_charging_full.svg',
  },
  {
    name: 'copyright',
    path: 'assets/icons/material/copyright.svg',
  },
  {
    name: 'electrical_services',
    path: 'assets/icons/material/electrical_services.svg',
  },
  {
    name: 'av_timer',
    path: 'assets/icons/material/av_timer.svg',
  },
  {
    name: 'developer_board',
    path: 'assets/icons/material/developer_board.svg',
  },
  {
    name: 'flag',
    path: 'assets/icons/material/flag.svg',
  },
  {
    name: 'currency_exchange',
    path: 'assets/icons/material/currency_exchange.svg',
  },
  {
    name: 'chat',
    path: 'assets/icons/material/chat.svg',
  },
  {
    name: 'article',
    path: 'assets/icons/material/article.svg',
  },
  {
    name: 'star',
    path: 'assets/icons/material/star.svg',
  },
] as const;

export type FigmaIconName = (typeof FIGMA_ICONS)[number]['name'];

export const FIGMA_ICON_MAP = Object.fromEntries(FIGMA_ICONS.map(icon => [icon.name, icon.path])) as Record<
  FigmaIconName,
  (typeof FIGMA_ICONS)[number]['path']
>;

export const FIGMA_ICON_NAMES = [...FIGMA_ICONS].map(icon => icon.name).sort((a, b) => a.localeCompare(b));
